// specify odata error codes that represent user errors
export const errorCodes = [
  'BUDGETAMOUNTISABOVELIMIT',
  'BUDGETAMOUNTISBELOWLIMIT',
  'DEFAULTHOTELGROUPUPDATENOTALLOWED',
  'MAXSUBACCOUNTLIMITATIONREACHED',
  'ENTITYDOESNOTEXIST', // fix bug 3532459:400 error with error code EntityDoesNotExist
];
